


import { object, string } from "yup";

import { useFormik } from "formik";
import toast from "react-hot-toast";
import axios from 'axios';
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import AuthHeroSection from "./AuthHeroSection";
import AuthLangButton from "../../components/authLangButton/AuthLangButton";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { setToken } from "@/store/token.slice";
import { setUser } from "@/store/user.slice";
import { setResturant } from "@/store/resturant.slice";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import i18n from "@/i18n";
import { setWarning } from "@/store/warningSlice";

export default function ActivateAccount() {
  const baseUrl = import.meta.env.VITE_BASE_URL
  const navigate = useNavigate()
  const token = useSelector((state: { auth: { token: string } }) => state.auth.token);
  const { t } = useTranslation();
  const [timer, setTimer] = useState(0)
  const dispatch = useDispatch()
  const lang = i18n.language

  // activate account function
  async function activateAccount() {
    const toastId = toast.loading(t("activateAccount.activating") as string)
    try {
      const options = {
        url: `${baseUrl}/api/dashboard/users/activate?locale=${lang}`,
        method: "POST",
        headers: {
          Authorization: token,
        },
        data: {
          otp: formik.values.code
        }
      }
      const response = await axios.request(options)
      if (response.data.success == true) {
        toast.success("User Registered Successfully")
        dispatch(setToken(response.data.accessToken));
        dispatch(setUser(response.data.userData));
        dispatch(setResturant(response.data.restaurantData));
        dispatch(setWarning({ show: true }));
        navigate("/")
      } else if (response.data.success == false) {
        toast.error(response.data.error)
      }
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        toast.error(error.response.data.error)
      } else {
        toast.error("An unexpected error occurred")
      }
    } finally {
      toast.dismiss(toastId)
    }
  }

  // validationSchema
  const validationSchema = object({
    code: string().required(t("activateAccount.codeRequired") as string),
  })
  // controlled inputs 
  const formik = useFormik({
    initialValues: {
      code: "",

    },
    validationSchema,
    onSubmit: activateAccount
  })



  async function resendOtp() {
    const toastId = toast.loading(t("activateAccount.sendingEmail") as string)
    try {
      const options = {
        url: `${baseUrl}/api/dashboard/users/activate/resend?locale=${lang}`,
        method: "POST",
        headers: {
          Authorization: token,
        },
      }

      const response = await axios.request(options)
      if (response.data.success == true) {
        toast.success(t("activateAccount.codeSent") as string)
        setTimer(30)
      } else if (response.data.success == false) {
        setTimer(response.data.remainingTime)

        toast.error(t("activateAccount.waitBeforeResend", { time: response.data.remainingTime }) as string)
      }
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {

        toast.error(t("activateAccount.tryAgain") as string)
      } else {
        toast.error("An unexpected error occurred")
      }
    } finally {

      toast.dismiss(toastId)
    }


  }
  useEffect(() => {
    let interval: NodeJS.Timeout;

    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => {
          if (prevTimer > 0) {
            return prevTimer - 1;
          } else {
            clearInterval(interval); // Stop the interval when timer reaches 0
            return 0;
          }
        });
      }, 1000);
    }

    // Cleanup the interval on unmount
    return () => clearInterval(interval);
  }, [timer]);
  return (
    <div className="xl:grid xl:grid-cols-12">

      <form
        onSubmit={formik.handleSubmit}
        className=" h-[75vh] relative mt-10 flex justify-between w-[90%] md:w-[60%] xl:w-[70%] mx-auto flex-col col-span-4 "
      >
        <AuthLangButton />
        <div className="flex flex-col gap-5 w-full  p-5">

          <h1 className="my-2  text-xl font-semibold">
            {t("activateAccount.title")}
          </h1>
          <div>{t("activateAccount.enterCodeInstruction")}</div>
          <div className="flex w-full  flex-col gap-3">
            <div className="flex flex-col gap-2">
              <label className="font-semibold">  {t("activateAccount.code")}</label>
              <input
                maxLength={4}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                value={formik.values.code}
                name="code"
                type="text"
                className="input"
                placeholder={t("activateAccount.enterCode") as string}
              />
              {formik.errors.code && formik.touched.code && <span className="text-red-500 text-sm">{formik.errors.code}</span>}
            </div>
            <button onClick={resendOtp} type="button" disabled={timer > 0} className="cursor-pointer disabled:text-gray-500 disabled:cursor-not-allowed w-fit flex items-center gap-5 font-semibold text-sidebar">      {t("activateAccount.resendCode")} <span className="text-sm text-sidebar"> {timer > 0 ? timer : ""} {timer > 0 && t("activateAccount.second")}</span> </button>
            <button type="submit" className="my-btn">
              {t("activateAccount.activate")}
            </button>
            <Link to="/login" className="text-sidebar mx-auto flex items-center gap-2 ">        {t("activateAccount.backToLogin")}
              {i18n.language === "ar" ? <FaChevronLeft className="text-sm" /> : <FaChevronRight className="text-sm" />}
            </Link>
          </div>
        </div>
      </form>
      <AuthHeroSection />
    </div>
  )
}


